import { Link } from "react-router-dom";
// import { blog_posts } from "../data";
import { useBlogs } from "../../../hooks/apis/blog";

function Blog_content() {
  const { data, isLoading, error } = useBlogs();

  return (
    <div className="content">
      <div className={isLoading ? "active loading position-fixed" : "loading position-fixed"}>
        <img src="/images/loading.svg" className="img-fluid" alt="loading" />
      </div>
      {data && data.blogs?.map((post, index) => {
        return (
          <div className="post" key={index}>
            <Link to={`/blog/post/${post.slug}`}></Link>
            <div className="img-box">
              <img
                src={post.photo}
                alt={post.title}
                title={post.title}
                className="img-fluid"
              />
            </div>
            <div className="info-box">
              <h2>{post.title}</h2>
              <p>{post.description}</p>
              <div className="detail">
                <span className="comment-count">
                  <i className="fas fa-comment"></i>
                  {post.comments_count} نظر
                </span>
                <span className="date">
                  <i className="fas fa-calendar"></i>
                  {post.created_at}
                </span>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default Blog_content;
